import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ClientViewModel } from '../../models-views/client.view.model';
import { NzModalService } from 'ng-zorro-antd/modal';
import { QuickAddService } from '../../services/quick-add.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-client-address-detail',
  standalone: false,
  templateUrl: './client-address-detail.component.html',
  styleUrl: './client-address-detail.component.scss'
})
export class ClientAddressDetailComponent {

  @Input() isVisible = false;
  @Input() data :any[] = [];
  @Output() closeDrawer = new EventEmitter<boolean>();
  @Output() updateAddressEvent = new EventEmitter<boolean>();
  private destroy$ = new Subject<boolean>();

  constructor(private vmc :ClientViewModel, private modal: NzModalService,private quickAddService: QuickAddService,){
    // this.quickAddService.refreshData.pipe(takeUntil(this.destroy$)).subscribe(e => {
    //          if (e) {
    //              this.vmc.getClientAddressId(this.data?.id)
    //          }
    // })
  }

  ngOnInit(): void {
    this.vmc.parentClientAddressDetailComponent = this;
  }


  updateAddress(address: any){
    this.updateAddressEvent.next(address);
  }

  deleteAddress(address: any){
     this.modal.confirm({
      nzTitle: 'Are you sure you want to delete this address?',
      nzContent: '<b style="color: red;">This action cannot be undone.</b>',
      nzOkText: 'Yes',
      nzOkType: 'primary',
      nzOkDanger: true,
      nzOnOk: () => this.vmc.deleteClientAddress(address.id),
      nzCancelText: 'No',
      nzOnCancel: () => console.log('Cancel')
    });
  }

  addressDelete(id: number){
    this.data = this.data.filter((item: any) => item.id !== id);
    // if(this.data.length == 0){ 
    // }
     this.closeWithRefreshData();
  }

  closeModal(){
    this.isVisible = false;
    this.closeDrawer.next(false);
  }

  closeWithRefreshData(){
    this.isVisible = false;
     this.closeDrawer.next(true);
  }
 

  formattedAddress(address): string {
    const addr = address;
    if (!addr) return '';

    return [
      addr.address_field_1,
      addr.address_field_2,
      addr.city_name,
      addr.state_name,
      addr.zip_code,
      addr.country_name
    ]
      .filter(part => !!part)
      .join(', ');
  }


  getAddressIcon(type: string): string {
    switch(type){
      case 'Offcial':
        return 'home' 
      case 'Shipping':
        return 'truck'
      case 'Billing':
        return 'shop'
      default:
        return 'info-circle'
    }
  }

  getIconTheme(type: string) {
    switch(type){
      case 'Offcial':
        return 'fill'  
      default:
        return 'outline'
    }
  }

}
